import { render, staticRenderFns } from "./r-avatar-dropdown.vue?vue&type=template&id=75c4ee0f"
import script from "./r-avatar-dropdown.vue?vue&type=script&lang=js"
export * from "./r-avatar-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c4ee0f')) {
      api.createRecord('75c4ee0f', component.options)
    } else {
      api.reload('75c4ee0f', component.options)
    }
    module.hot.accept("./r-avatar-dropdown.vue?vue&type=template&id=75c4ee0f", function () {
      api.rerender('75c4ee0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/avatar/r-avatar-dropdown.vue"
export default component.exports